import domReady from '@wordpress/dom-ready';
import * as Focus from '../common/focus';

domReady(() => {
  const openQuickNav = document.getElementById('quick-nav-trigger');
  const closeQuickNav = document.getElementById('close-quick-nav');
  const quickNavModal = document.getElementById('quick-nav-modal');

  //ouverture de la fenetre
  if (openQuickNav) {
    openQuickNav.addEventListener('click', function () {
      $('#quick-nav-trigger').attr('aria-expanded', 'true');
      $('.close-window').attr('aria-expanded', 'true');
      $('.quick-nav__modal').addClass('quick-nav-open');
      $('.quick-nav__modal').removeClass('quick-nav-close');
      setTimeout(function () {
        document.documentElement.classList.add('lockedPosition');
      }, 1000);

      if (quickNavModal.classList.contains('quick-nav__modal')) {
        Focus.trapFocusInside(jQuery('#quick-nav-modal'));
      }
    });
  }

  if (closeQuickNav) {
    closeQuickNav.addEventListener('click', function () {
      $('.close-window').attr('aria-expanded', 'false');
      $('#quick-nav-trigger').attr('aria-expanded', 'false');
      $('.quick-nav__modal').addClass('quick-nav-close');
      $('.quick-nav__modal').removeClass('quick-nav-open');
      document.documentElement.classList.remove('lockedPosition');

      if (quickNavModal.classList.contains('quick-nav__modal')) {
        Focus.untrapFocusInside(jQuery('#quick-nav-modal'));
      }
    });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') {
        $('.close-window').attr('aria-expanded', 'false');
        $('#quick-nav-trigger').attr('aria-expanded', 'false');
        $('.quick-nav__modal').addClass('quick-nav-close');
        $('.quick-nav__modal').removeClass('quick-nav-open');
        document.documentElement.classList.remove('lockedPosition');

        if (quickNavModal.classList.contains('quick-nav__modal')) {
          Focus.untrapFocusInside(jQuery('#quick-nav-modal'));
        }
      }
    });
  }
});
